import styled from 'styled-components';
import { Col } from '@components/Grid';

const StyledColItem = styled(Col)`
  cursor: pointer;
  display: flex;
  align-items: stretch;
  flex-grow: 0;
  margin: ${({ theme, withMargin }) =>
    withMargin ? theme.spacing(0, 6, 6, 0) : theme.spacing(0)};
`;

export default StyledColItem;
